import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialLoading = createSlice({
  name: 'initialLoading',
  initialState: true,
  reducers: {
    setIsInitialLoading: (state, action: PayloadAction<boolean>) => action.payload,
  },
});

export default initialLoading.reducer;
export const { setIsInitialLoading } = initialLoading.actions;
